class CardsType {
  constructor(cardId: number, name: string, tooltipMessage?: string) {
    this.cardId = cardId;
    this.name = name;
    this.tooltipMessage = tooltipMessage;
  }

  cardId: number;
  name: string;
  tooltipMessage?: string;
}

export const cardsInfo = {
  cards: [
    new CardsType(1, 'totalVisitors'),
    new CardsType(2, 'conversions'),
    new CardsType(3, 'bounce'),
    new CardsType(4, 'mobileVisitors'),
    new CardsType(5, 'mobileConversions'),
    new CardsType(6, 'averageTimeOnExperience', 'The average time only consider users that have done at least one action on the page.'),
    new CardsType(7, 'topSourceOfTraffic'),
    new CardsType(8, 'spikesOnVisitors'),
    new CardsType(9, 'spikesOnConversion'),
    new CardsType(10, 'spikesOnBounce'),
    new CardsType(11, 'betterTrafficSource', 'The source with the highest percentage of conversions in the period.'),
    new CardsType(12, 'worstTrafficSource', 'The source with the lowest percentage of conversions in the period.'),
    new CardsType(13, 'betterDayForEngagement', 'The day of the week with most visitors.'),
    new CardsType(14, 'betterTimeForEngagement', 'The time of day with the most visitors.'),
    new CardsType(15, 'mostEngagedTag', 'The tag that the audience has interacted (clicked) the most.'),
    new CardsType(16, 'leastEngagedTag', 'The tag that the audience has interacted (clicked) the least.'),
    new CardsType(17, 'preConversionVsConversion'),
    new CardsType(18, 'mostEngagedCreative'),
    new CardsType(19, 'leastEngagedCreative'),
    new CardsType(20, 'mostEngagedPage', 'Page that the audience has visited the most.'),
    new CardsType(21, 'leastEngagedPage', 'Page that the audience has visited the least.'),
    new CardsType(22, 'insightsOnViewport'),
    new CardsType(23, 'capacity'),
    new CardsType(24, 'traffic'),
    new CardsType(25, 'mostEngagedCampaign'),
    new CardsType(26, 'leastEngagedCampaign'),
    new CardsType(27, 'highestAverageScoreSpeed'),
    new CardsType(28, 'lowestAverageScoreSpeed'),
    new CardsType(28, 'lowestAverageScoreSpeed'),
    new CardsType(29, 'criticalDropoff'),
    new CardsType(30, 'averageDropoff'),
    new CardsType(32, "creativeGoal"),
    new CardsType(33, "creativeTargetAudience"),
    new CardsType(34, "creativeGoalDueDate")
  ]
}

export const findCard = (cardId : number) => {
  return cardsInfo.cards.find(_ => _.cardId === cardId);
}

export const numberWithCommas = (x : string | number) : string => {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}